import { render, staticRenderFns } from "./SubStyle.vue?vue&type=template&id=82d80a12&"
import script from "./SubStyle.vue?vue&type=script&lang=js&"
export * from "./SubStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports